import { ComponentCommonDays } from '@/graphql/generated/graphql';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { downloadCalendarEvent, generateGoogleCalendarUrl, generateMicrosoftUrl } from '../../utils/calendar-utils';

interface CalendarDropdownProps {
  event: ComponentCommonDays;
}

const calendarOptions = [
  {
    name: 'Apple',
    action: 'download',
  },
  {
    name: 'Google',
    action: 'google',
  },
  {
    name: 'Outlook',
    action: 'outlook',
  },
];

export const CalendarDropdown = ({ event }: CalendarDropdownProps) => {
  const handleCalendarAction = (action: string) => {
    if (action === 'download') {
      downloadCalendarEvent(event);
    } else {
      const urlMap = {
        google: generateGoogleCalendarUrl,
        outlook: generateMicrosoftUrl,
      };

      const urlGenerator = urlMap[action as keyof typeof urlMap];
      if (urlGenerator) {
        window.open(urlGenerator(event), '_blank');
      }
    }
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="!my-0 text-sh-xxs font-bold hover:text-blue-500">Add to your calendar</Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95">
        <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {calendarOptions.map((option) => (
              <Menu.Item key={option.name}>
                {({ active }) => (
                  <button
                    onClick={() => handleCalendarAction(option.action)}
                    className={`${
                      active ? 'bg-gray-50' : ''
                    } flex w-full items-center px-4 py-2 text-sh-xxs text-gray-900`}>
                    <span>{option.name}</span>
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
